<div class="alert alert-success d-flex align-items-center" id="size" [style.display]="closebtn"role="alert">
    <i class="fa fa-exclamation-triangle img-thumbnail"></i>
   <p id="text"> {{displaydata}}</p>
  </div>

